import React, { lazy, Suspense } from 'react'
import Loader from './components/Loader'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
const Home = lazy(() => import('./screen/Home'))
const Privacy = lazy(() => import('./screen/Privacy'))
const Terms = lazy(() => import('./screen/TermsCondition'))

const App = () => {
  return (
    <>
      <Router>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  )
}

export default App
